import Utils from './Utils';

const EMAIL_LAYOUT_TYPE_ORDER = 'order';

const ONE_TIME_PASS_ID = 'one-time-pass';

const PREVIEW_ORDER_ID = '12345';

export const PREVIEW_ORDER_PARTS_VARIANT = {
    TICKETS_ONLY: 'tickets_only',
    TICKETS_AND_PASS: 'tickets_and_pass',
    PASS_ONLY: 'pass_only',
    ARTICLES_ONLY: 'articles_only',
};

/**
 * Eshop order-confirmation copy — msgstr from eshop locale messages.po
 * (fr is the source msgid; en/de/it are translations).
 * Link labels under the ticket column use tkt_t('Télécharger'), never "PDF".
 */
const COPY = {
    fr: {
        thank_you: 'Nous vous remercions pour votre commande\u00a0!',
        print_tickets: "Imprimez ou téléchargez vos tickets dès aujourd'hui\u00a0!",
        print_tickets_named: "%s, imprimez ou téléchargez vos tickets dès aujourd'hui\u00a0!",
        order_pipe: 'Commande n°%s',
        description: 'Description',
        price: 'Prix',
        ticket_col: 'Billet',
        total: 'Total',
        receipt: 'Quittance',
        download_tickets: 'Télécharger tous les billets',
        order_number: 'Numéro de commande\u00a0: %s',
        buyer: 'Acheteur\u00a0: %s',
        payment_method: 'Méthode de paiement\u00a0: %s',
        sample_payment: 'Carte de crédit',
        pass_reservation:
            '<br/><br/>Rendez-vous sur %s ou directement aux caisses pour effectuer une réservation sur votre abonnement. Cette étape est <b><u>obligatoire pour vous garantir une place</u></b>.',
        sample_ticket_name: 'Entrée séance',
        sample_pass_name: 'Abonnement saison',
        sample_article_name: 'Programme de la saison',
        gift_opening: 'Vous avez reçu un cadeau\u00a0!',
        gift_heading: 'Vous avez reçu un cadeau.',
        gift_pipe: '%s vous a offert un cadeau',
        download: 'Télécharger',
        refund_pipe: 'Remboursement commande n°%s',
        refund_heading:
            'Bonjour%s,\n\nNous confirmons le remboursement de l\'article ci-dessous concernant votre commande n°%s.\n\nLe montant sera recrédité sur votre carte de paiement sous 5 jours ouvrables.',
        refund_method: 'Méthode de remboursement\u00a0: %s',
    },
    en: {
        thank_you: 'Thank you for your order!',
        print_tickets: 'Print or download your tickets today!',
        print_tickets_named: '%s, print or download your tickets today!',
        // messages.po: "%s | Commande n°%s" → "%s | Order n.%s"
        order_pipe: 'Order n.%s',
        description: 'Description',
        price: 'Price',
        ticket_col: 'Ticket',
        total: 'Total',
        receipt: 'Receipt',
        download_tickets: 'Download all tickets',
        order_number: 'Order n#: %s',
        buyer: 'Buyer\u00a0: %s',
        payment_method: 'Payment method\u00a0: %s',
        sample_payment: 'Credit card',
        pass_reservation:
            '<br/><br/>Please go at %s or directly at point of sales to book your events on a pass. This step is <b><u>mandatory to guarantee a seat</u></b>.',
        sample_ticket_name: 'Single-session admission',
        sample_pass_name: 'Season pass',
        sample_article_name: 'Season programme',
        gift_opening: 'You have received a gift!',
        gift_heading: 'You have received a gift.',
        gift_pipe: '%s has given you a gift',
        download: 'Download',
        refund_pipe: 'Refund for order n.%s',
        refund_heading:
            'Hello%s,\n\nWe confirm the refund of the item below for your order n.%s.\n\nThe amount will be credited back to your payment card within 5 business days.',
        refund_method: 'Refund method\u00a0: %s',
    },
    de: {
        thank_you: 'Wir danken Ihnen für Ihre Bestellung!',
        print_tickets: 'Drucken Sie oder laden Sie ihre Tickets noch heute herunter!',
        print_tickets_named: '%s, drucken Sie oder laden Sie ihre Tickets noch heute herunter!',
        order_pipe: 'Bestellung Nr.%s',
        description: 'Beschreibung',
        price: 'Preis',
        ticket_col: 'Tickets',
        total: 'Gesamt',
        receipt: 'Quittung',
        download_tickets: 'Tickets herunterladen',
        order_number: 'Bestellnummer: %s',
        buyer: 'Käufer\u00a0: %s',
        payment_method: 'Zahlungsmethode\u00a0: %s',
        sample_payment: 'Kreditkarte',
        pass_reservation:
            '<br/><br/>An der Kasse oder unter %s können Sie mit Ihrem Pass einen Platz reservieren. Reservationen sind <b><u>obligatorisch und garantieren einen Sitzplatz </u></b>.',
        sample_ticket_name: 'Einzeleintritt',
        sample_pass_name: 'Saisonabo',
        sample_article_name: 'Saisonprogramm',
        gift_opening: 'Sie haben ein Geschenk erhalten!',
        gift_heading: 'Sie haben ein Geschenk erhalten.',
        gift_pipe: '%s hat Ihnen ein Geschenk gemacht.',
        download: 'Herunterladen',
        refund_pipe: 'Rückerstattung Bestellung Nr.%s',
        refund_heading:
            'Guten Tag%s,\n\nWir bestätigen die Rückerstattung des untenstehenden Artikels für Ihre Bestellung Nr.%s.\n\nDer Betrag wird innerhalb von 5 Werktagen auf Ihre Zahlungskarte zurückerstattet.',
        refund_method: 'Rückerstattungsmethode\u00a0: %s',
    },
    it: {
        thank_you: 'Grazie per il tuo ordine!',
        print_tickets: 'Stampa o scarica i tuoi biglietti oggi!',
        print_tickets_named: '%s, stampa o scarica i tuoi biglietti oggi!',
        order_pipe: 'Ordine n°%s',
        description: 'Descrizione',
        price: 'Prezzo',
        ticket_col: 'Biglietto',
        total: 'Totale',
        receipt: 'Ricevuta',
        download_tickets: 'Scarica tutti i biglietti',
        order_number: "Numero d'ordine: %s",
        buyer: 'Acquirente: %s',
        payment_method: 'Metodo di pagamento: %s',
        sample_payment: 'Carta di credito',
        // msgstr has missing space after %s (upstream eshop string)
        pass_reservation:
            '<br/><br/>Vai su %so direttamente alle casse per effettuare una prenotazione per il tuo abbonamento. Questo passaggio è <b><u>obbligatorio per garantirti un posto</u></b>.',
        sample_ticket_name: 'Ingresso singola proiezione',
        sample_pass_name: 'Abbonamento stagionale',
        sample_article_name: 'Programma della stagione',
        gift_opening: 'Hai ricevuto un regalo!',
        gift_heading: 'Hai ricevuto un regalo.',
        gift_pipe: '%s ti ha fatto un regalo',
        download: 'Scarica',
        refund_pipe: 'Rimborso ordine n.%s',
        refund_heading:
            'Buongiorno%s,\n\nConfermiamo il rimborso dell\'articolo qui sotto relativo al tuo ordine n.%s.\n\nL\'importo sarà riaccreditato sulla tua carta di pagamento entro 5 giorni lavorativi.',
        refund_method: 'Metodo di rimborso: %s',
    },
};

const LOREM = {
    fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor.',
    en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor.',
    de: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor.',
};

function lang_key(lang) {
    const key = (lang || 'fr').substring(0, 2);
    return COPY[key] ? key : 'fr';
}

function format(template, ...args) {
    let i = 0;
    return template.replace(/%s/g, () => args[i++] ?? '');
}

function resolve_home_url(setting, lang) {
    const eshop = setting?.eshop || {};
    const key = lang_key(lang);
    const localized = eshop.url_overrides?.home_url?.[key];
    if (localized)
        return localized;
    return eshop.uri || 'https://example.com';
}

function resolve_variant_flags({ variant, tickettype }) {
    if (variant === PREVIEW_ORDER_PARTS_VARIANT.ARTICLES_ONLY)
        return { has_ticket: false, has_pass: false };

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.TICKETS_AND_PASS)
        return { has_ticket: true, has_pass: true };

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.TICKETS_ONLY)
        return { has_ticket: true, has_pass: false };

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.PASS_ONLY)
        return { has_ticket: false, has_pass: true };

    const is_one_time_pass = tickettype?._id === ONE_TIME_PASS_ID;
    return {
        has_ticket: Boolean(is_one_time_pass),
        has_pass: Boolean(tickettype && !is_one_time_pass),
    };
}

function build_pass_reservation_html(t, setting, lang) {
    const home_url = resolve_home_url(setting, lang);
    return format(t.pass_reservation, `<a href="${home_url}">${home_url}</a>`);
}

function build_item_row(t, item_name, price, has_ticket) {
    const ticket_cell = has_ticket
        ? `<td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;"><a href="#">${t.download}</a></td>`
        : '';

    return `
<tr>
  <td style="padding: 8px 0;">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="${has_ticket ? '50%' : '75%'}" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;">${item_name}</td>
        <td width="20%" align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;">${price}</td>
        ${ticket_cell}
      </tr>
    </table>
  </td>
</tr>`;
}

function build_sample_item_table(t, rows, has_ticket, ticket_col, total_price) {
    const col3 = has_ticket
        ? `<table cellpadding="0" cellspacing="0" border="0" width="25%" align="right"><tr><td><th align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${ticket_col}</th></td></tr></table>`
        : '';

    const item_rows = rows.map(row => build_item_row(t, row.name, row.price, has_ticket)).join('');
    const ticket_footer = has_ticket
        ? `<td width="25%" align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;"><a href="#">${t.receipt}</a></td>`
        : '';

    return `
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 550px;">
  <tr>
    <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>
          <td valign="top">
            <table cellpadding="0" cellspacing="0" border="0" width="${has_ticket ? '50%' : '75%'}" align="left">
              <tr><td style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;"><b>${t.description}</b></td></tr>
            </table>
            <table cellpadding="0" cellspacing="0" border="0" width="20%" align="left">
              <tr><td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;"><b>${t.price}</b></td></tr>
            </table>
            ${col3}
          </td>
        </tr>
      </table>
    </td>
  </tr>
  ${item_rows}
  <tr>
    <td style="padding: 10px 0; border-top: 1px solid #eaeaea; border-bottom: 1px dashed #aaaaaa;">
      <table width="100%">
        <tr>
          <td width="${has_ticket ? '50%' : '75%'}" align="right" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;"><b>${t.total}</b></td>
          <td width="20%" align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;"><b>${total_price}</b></td>
          ${ticket_footer}
        </tr>
      </table>
    </td>
  </tr>
  ${has_ticket ? `
  <tr>
    <td align="center" style="padding-top: 16px;">
      <a href="#" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; background: #256F9C; padding: 12px 20px; border-radius: 3px; text-decoration: none; display: inline-block;">${t.download_tickets}</a>
    </td>
  </tr>` : ''}
</table>`;
}

function build_sample_item_row(t, item_name, price, has_ticket) {
    return build_sample_item_table(t, [{ name: item_name, price }], has_ticket, t.ticket_col, price);
}

function resolve_sample_rows({ variant, tickettype, t, key }) {
    const ticket_name = tickettype && variant !== PREVIEW_ORDER_PARTS_VARIANT.ARTICLES_ONLY
        ? (Utils.localized_or_fallback(tickettype.name, key) || tickettype._id)
        : t.sample_ticket_name;

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.ARTICLES_ONLY)
        return [{ name: t.sample_article_name, price: '15.00 CHF' }];

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.PASS_ONLY)
        return [{ name: t.sample_pass_name, price: '180.00 CHF' }];

    if (variant === PREVIEW_ORDER_PARTS_VARIANT.TICKETS_AND_PASS)
        return [
            { name: ticket_name || t.sample_ticket_name, price: '25.00 CHF' },
            { name: t.sample_pass_name, price: '180.00 CHF' },
        ];

    return [{ name: ticket_name || t.sample_ticket_name, price: '25.00 CHF' }];
}

function build_sample_gift_item_row(t, item_name, has_ticket) {
    const ticket_cell = has_ticket
        ? `<td align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;"><a href="#">${t.download}</a></td>`
        : '';
    const col3 = has_ticket
        ? `<th align="center" style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;">${t.ticket_col}</th>`
        : '';

    return `
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 550px;">
  <tr>
    <td style="padding: 10px 0 0 0; border-top: 1px dashed #aaaaaa;">
      <table cellspacing="0" cellpadding="0" border="0" width="100%">
        <tr>
          <td valign="top">
            <table cellpadding="0" cellspacing="0" border="0" width="${has_ticket ? '75%' : '100%'}" align="left">
              <tr><td style="font-family: Arial, sans-serif; color: #333333; font-size: 16px;"><b>${t.description}</b></td></tr>
            </table>
            ${has_ticket ? `<table cellpadding="0" cellspacing="0" border="0" width="25%" align="right"><tr><td>${col3}</td></tr></table>` : ''}
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr>
    <td style="padding: 8px 0;">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td width="${has_ticket ? '75%' : '100%'}" style="font-family: Arial, sans-serif; color: #333333; font-size: 14px;">${item_name}</td>
          ${ticket_cell}
        </tr>
      </table>
    </td>
  </tr>
  ${has_ticket ? `
  <tr>
    <td align="center" style="padding-top: 16px;">
      <a href="#" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; background: #256F9C; padding: 12px 20px; border-radius: 3px; text-decoration: none; display: inline-block;">${t.download_tickets}</a>
    </td>
  </tr>` : ''}
</table>`;
}

/**
 * True when the layout widgets embed [order.parts.heading] in any language.
 * Used to avoid duplicating the pass reservation notice in preview content.
 *
 * @param {Object|null|undefined} layout
 * @returns {boolean}
 */
export function layout_embeds_order_parts_heading(layout) {
    if (!layout)
        return false;

    const widgets = layout.widgets || [];
    return widgets.some(widget => {
        if (widget.type !== 'text')
            return false;
        const texts = widget.options?.text;
        if (!texts || typeof texts !== 'object')
            return false;
        return Object.values(texts).some(
            text => typeof text === 'string' && text.includes('[order.parts.heading]')
        );
    });
}

/**
 * Sample order confirmation fragments (aligned with eshop Email::build_parts_from_cart).
 *
 * @param {{ lang?: string, setting?: Object, tickettype?: Object, contact?: Object, variant?: string, ticket_col_label?: string, layout?: Object, mirror_pass_notice_in_content?: boolean }} params
 */
export function build_preview_order_parts({ lang, setting, tickettype, contact, variant, ticket_col_label, layout, mirror_pass_notice_in_content }) {
    const key = lang_key(lang);
    const t = { ...COPY[key] };
    if (ticket_col_label)
        t.ticket_col = ticket_col_label;

    const { has_ticket, has_pass } = resolve_variant_flags({ variant, tickettype });

    const buyer_name = contact
        ? `${contact.firstname || ''} ${contact.lastname || ''}`.trim()
        : '';

    const customer_short = Utils.localized_or_fallback(setting?.customer?.name_short, key, '')
        || Utils.localized_or_fallback(setting?.customer?.name, key, '');

    const subject = `${customer_short} | ${format(t.order_pipe, PREVIEW_ORDER_ID)}`;

    let heading = t.thank_you;
    const pass_reservation_html = has_pass ? build_pass_reservation_html(t, setting, key) : '';
    if (pass_reservation_html)
        heading += pass_reservation_html;

    const rows = resolve_sample_rows({ variant, tickettype, t, key });
    const total_price = variant === PREVIEW_ORDER_PARTS_VARIANT.TICKETS_AND_PASS
        ? '205.00 CHF'
        : rows[0].price;

    let content = build_sample_item_table(t, rows, has_ticket, t.ticket_col, total_price);
    // Eshop appends the pass notice to heading only. Mirror it in content so layouts that
    // only embed [order.parts.content] still preview the reservation instruction — but not
    // when heading is already in the layout (would show the notice twice in the preview).
    const should_mirror_in_content = mirror_pass_notice_in_content !== undefined
        ? mirror_pass_notice_in_content
        : !layout_embeds_order_parts_heading(layout);
    if (pass_reservation_html && should_mirror_in_content)
        content += pass_reservation_html;

    const buyer_block = buyer_name
        ? `${buyer_name}\n${contact?.email || ''}`
        : (contact?.email || '');

    let payment = `${format(t.order_number, PREVIEW_ORDER_ID)}\n`;
    if (buyer_block)
        payment += `${format(t.buyer, buyer_block)}\n`;
    payment += `${format(t.payment_method, t.sample_payment)}`;
    payment = payment.replace(/\n/g, '<br/>');

    return {
        subject,
        heading,
        content,
        payment,
    };
}

/**
 * Sample refund confirmation fragments (aligned with eshop Email::build_parts_from_refund_confirmation).
 *
 * @param {{ lang?: string, setting?: Object }} params
 */
export function build_preview_refund_parts({ lang, setting }) {
    const key = lang_key(lang);
    const t = COPY[key];

    const customer_short = Utils.localized_or_fallback(setting?.customer?.name_short, key, '')
        || Utils.localized_or_fallback(setting?.customer?.name, key, '');

    const subject = `${customer_short} | ${format(t.refund_pipe || 'Remboursement commande n°%s', PREVIEW_ORDER_ID)}`;

    const heading = format(
        t.refund_heading || 'Bonjour%s, nous confirmons le remboursement de l\'article ci-dessous concernant votre commande n°%s.',
        ', Jean',
        PREVIEW_ORDER_ID
    ).replace(/\n/g, '<br/>');

    const content = build_sample_item_row(t, t.description, '25.00 CHF', false);

    let payment = `${format(t.order_number, PREVIEW_ORDER_ID)}\n`;
    payment += `${format(t.refund_method || 'Méthode de remboursement : %s', t.sample_payment)}`;
    payment = payment.replace(/\n/g, '<br/>');

    return {
        subject,
        heading,
        content,
        payment,
    };
}

/**
 * Sample gift notification fragments (aligned with eshop Email::build_parts_from_gift_item).
 *
 * @param {{ lang?: string, setting?: Object, contact?: Object }} params
 */
export function build_preview_gift_parts({ lang, setting, contact }) {
    const key = lang_key(lang);
    const t = COPY[key];

    const buyer_name = contact
        ? `${contact.firstname || ''} ${contact.lastname || ''}`.trim()
        : 'Jean Dupont';

    const customer_short = Utils.localized_or_fallback(setting?.customer?.name_short, key, '')
        || Utils.localized_or_fallback(setting?.customer?.name, key, '');

    const subject = `${customer_short} | ${format(t.gift_pipe, buyer_name)}`;

    const opening = t.gift_opening;
    const heading = t.gift_heading;
    const content = build_sample_gift_item_row(t, t.description, true);

    return {
        subject,
        opening,
        heading,
        content,
        head: '',
        payment: null,
    };
}

/**
 * @param {string} lang
 * @returns {{ fr: string, en: string, de: string }}
 */
export function build_preview_custom_text() {
    return { fr: LOREM.fr, en: LOREM.en, de: LOREM.de };
}

/**
 * Detect whether an e-mail layout uses order confirmation shortcodes.
 *
 * @param {Object} layout
 * @param {Object} setting
 * @returns {boolean}
 */
export function is_order_parts_email_layout(layout, setting) {
    if (!layout || layout.layout_type !== 'email')
        return false;

    if (layout.type)
        return layout.type === EMAIL_LAYOUT_TYPE_ORDER;

    if (setting?.email_layouts?.order_confirmation &&
        String(setting.email_layouts.order_confirmation) === String(layout._id))
        return true;

    return Utils.langs().some(lang => {
        const text = (layout.widgets || [])
            .filter(w => w.type === 'text')
            .map(w => w.options?.text?.[lang] || '')
            .join(' ');
        return text.includes('[order.parts.');
    });
}
